import React from "react";
import { Card, CardBody, InputGroup } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay, getSelectedDaysAgo } from "../../helpers/utils";
import CustomMultipleDateRange from "../CustomMultipleDateRange/CustomMultipleDateRange";
import ReactSelect from "react-select";
import { AvForm } from "availity-reactstrap-validation";
import { debounce } from "lodash";
import MonthRangePicker from "../MonthRangePicker";

const DynamicFormFilters = props => {
  const [date, setDate] = React.useState({});
  const [process, setProcess] = React.useState("INITIAL");
  const [filters, setFilters] = React.useState({});
  const [oldFilters, setOldFilters] = React.useState(filters);

  const TimeoutDelay = React.useMemo(() => {
    return props.filterDelay || 2000;
  }, [props.filterDelay]);

  React.useEffect(() => {

    setDate(
      `${props.selectedDate !== null
        ? props.selectedDate.start_date
        : getSelectedDaysAgo(31)
      } to ${props.selectedDate !== null
        ? props.selectedDate.end_date
        : getCurrentDay()
      }`
    );

  }, []);

  const handlePermitSelect = (data, filterType) => {
    let filteredData = {};
    filteredData[filterType] = [];

    if (Array.isArray(data)) {
      data.map(i => filteredData[filterType].push(i.value));
    } else {
      filteredData[filterType].push(data.value);
    }

    props.onFiltersChange({
      ...filters,
      ...filteredData,
    }, "permit", process);
  };

  const handleSelect = (data, filterType) => {
    let filteredData = {};
    filteredData[filterType] = [];

    if (Array.isArray(data)) {
      data.map(i => filteredData[filterType].push(i.value));
    } else {
      filteredData[filterType].push(data.value);
    }

    setFilters(prev => ({
      ...prev,
      [filterType]: filteredData[filterType],
    }));
  };

  const debouncedHandleFiltersChange = debounce(newFilters => {
    if (Object.keys(newFilters).length > 0) {
      props.onFiltersChange(filters, "filters", process);
      setProcess("USED");
    }
  }, 500);

  React.useEffect(() => {
    let timeoutId;

    const handleFiltersChange = newFilters => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(
        () => debouncedHandleFiltersChange(newFilters),
        TimeoutDelay
      );
    };

    handleFiltersChange(filters);

    return () => {
      clearTimeout(timeoutId);
    };
    // debouncedHandleFiltersChange(filters);
  }, [filters]);

  const onFiltersChange = (date, key) => {
    if (date) {
      setDate(date);
      if (date.end_date !== undefined) {
        setFilters(prev => ({
          ...prev,
          start_date: date.start_date,
          end_date: date.end_date || getCurrentDay(),
        }));
        props.onDateRangeChange({
          start_date: date.start_date,
          end_date: date.end_date || getCurrentDay(),
        });
      }
    } else {
      setFilters(prev => ({
        ...prev,
        start_date: '',
        end_date: '',
      }));
    }
  };

  // const handleSetDefaultDate = (params, date_type) => {
  //   let date = "";
  //   if (
  //     params[date_type[0]] !== undefined &&
  //     params[date_type[1]] !== undefined
  //   ) {
  //     let current = {
  //       start_date: new Date(params[date_type[0]]),
  //       end_date: new Date(params[date_type[1]]),
  //     };
  //     const selectedDate = {
  //       start_date:
  //         new Date(current.start_date.setHours(12)).toJSON().split("T")[0] ||
  //         "",
  //       end_date:
  //         new Date(current.end_date.setHours(12)).toJSON().split("T")[0] || "",
  //     };
  //     date = selectedDate["start_date"] + " to " + selectedDate["end_date"];

  //     setFilters(prev => ({
  //       ...prev,
  //       start_date: selectedDate["start_date"],
  //       end_date: selectedDate["end_date"],
  //     }));

  //     return {
  //       start_date: selectedDate["start_date"],
  //       end_date: selectedDate["end_date"],
  //     };
  //   }
  // };

  const onlyMonthFilterChange = (date, key) => {
    let data = {};

    if (date) {
      setDate(date);
      let currentDate = new Date(date.value);
      let lastDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        currentDate.getDate(),
        0
      );

      data = {
        start_date: new Date(currentDate).toJSON().split("T")[0] || "",
        end_date: new Date(lastDay).toJSON().split("T")[0] || "",
      };
    }

    props.onFiltersChange(data, key);
  };

  const CalendarFilterChange = (date, key) => {
    let data = {};

    if (date) {

      let currentDate = new Date(date.start_date);
      data = {
        start_date: new Date(currentDate).toJSON().split("T")[0] || "",
      };
    }

    props.onFiltersChange(data, key);
  };

  return (
    <>
      <StyledRow>
        <div
          style={{
            background: "#f8f8fb",
            display: props?.disableFilterBy ? "none" : "",
          }}
        >
          <span style={{ fontWeight: "600", fontSize: "15px" }}>
            Filter by:
          </span>
        </div>
        <div className="col-12">
          <StyledCard cardcolor={props.cardcolor} >
            <CardBody
              style={{
                padding: "1rem 0",
                ...props.style,
              }}
            >
              <div className="row gy-2 gx-3 align-items-center">
                <FilterContainer className={`${props.FilterContainerClass}`}>
                  {props.dateFilters?.map((i, idx) => (
                    <div key={i.key + "_" + idx}>
                      {i?.onlyMonth ? (
                        <AvForm>
                          <PickerStyled
                            key={i.key + "_" + idx}
                            style={{
                              ...i.style,
                            }}
                          >
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              value={
                                props.filtered_params[`${i.filterType[0]}`]
                              }
                              className="form-control d-block"
                              placeholder={`Select ${i.plug || "date"}...`}
                              name={`-${idx}-between`}
                              defaultValue={getCurrentDay}
                              datePickerType={"calendar-with-static"}
                              customStyle={
                                {
                                  // ...i.style
                                }
                              }
                              onChange={date =>
                                onlyMonthFilterChange(date, i.key)
                              }
                              monthTextFormat
                              clearDate
                            />
                          </PickerStyled>
                        </AvForm>
                      ) : i?.dateRange ? (
                        <AvForm>
                          <PickerStyled
                            key={i.key}
                            style={{
                              width: i?.customWidth || "",
                              ...i?.style,
                            }}
                          >
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              defaultValue={getCurrentDay}
                              className="form-control d-block"
                              placeholder={`Select ${i.plug}...`}
                              name={`-${idx}-between`}
                              datePickerType="round"
                              value={
                                i?.value?.start_date
                                  ? i.value
                                  : '' // date || i?.value
                              }
                              onChange={date => onFiltersChange(date, i.key)}
                              clearDate={i?.clearDate ? true : false}
                              customStaticRanges={i?.customStaticRanges}
                            />
                          </PickerStyled>
                        </AvForm>
                      ) : i?.calendarPicker ? <>
                        <AvForm>
                          <PickerStyled
                            key={i.key}
                            style={{
                              width: i?.customWidth || "",
                              ...i?.style,
                            }}
                          >
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              placeholder="Select date..."
                              name={`${idx}-month`}
                              value={props.filtered_params[`${i.filterType[0]}`]}
                              datePickerType={"calendar"}
                              errorText="Date is required!"
                              // onChange={e => onlyMonthFilterChange(e)}
                              // monthTextFormat
                              className="form-control d-block"
                              customStyle={
                                {
                                  // ...i.style
                                }
                              }
                              onChange={date =>
                                CalendarFilterChange(date, i.key)
                              }
                              clearDate
                            />
                          </PickerStyled>
                        </AvForm>
                      </> : (
                        <>
                          <PickerStyled
                            key={i.key}
                            style={{
                              ...i?.style,
                            }}
                          // customwidth={i?.customWidth || ""}
                          >
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <MonthRangePicker
                              onChangeMonthRange={date =>
                                onFiltersChange(date, i.key)
                              }
                              defaultValue={[
                                new Date(i?.value.start_date),
                                new Date(i?.value?.end_date),
                              ]}
                            />
                          </PickerStyled>
                          {/* <AvForm>
                          <PickerStyled
                            key={i.key}
                            customwidth={i?.customWidth || ""}
                          >
                            {i.isTitle !== false && <p>{i.plug}:</p>}
                            <CustomMultipleDateRange
                              defaultValue={getCurrentDay}
                              className="form-control d-block"
                              placeholder={`Select ${i.plug}...`}
                              name={`-${idx}-between`}
                              datePickerType="round"
                              value={
                                i?.value?.start_date ? i.value : handleSetDefaultDate(
                                  props.filtered_params,
                                  i.filterType
                                ) || i?.value
                              }
                              onChange={date => onFiltersChange(date, i.key)}
                              clearDate={i?.clearDate ? true : false}
                              customStaticRanges
                            />
                          </PickerStyled>
                        </AvForm> */}
                        </>
                      )}
                    </div>
                  ))}
                  {props.filtersFields &&
                    props.filtersFields.map((i, key) => (
                      <React.Fragment key={key}>
                        <FilteredStyled
                          className={`col-sm-auto float-end gy-2 gx-3 ${i.hidden && "d-none"
                            }`}
                          style={{
                            ...i?.style,
                          }}
                          key={key + "filter-select"}
                        >
                          {i.isTitle !== false && <p>{i.title}:</p>}
                          {i?.singleSelect ? (
                            <CustomSelect
                              defaultValue={
                                i.defaultValue
                                  ? {
                                    label: i.defaultValue.name,
                                    value: i.defaultValue.id,
                                  }
                                  : {}
                              }
                              placeholder={i?.plug}
                              // value={this.state.selectedFilter}
                              // onChange={this.handleSelectStatus}
                              onChange={select =>
                                handlePermitSelect(select, i.filterType || null)
                              }
                              options={
                                i.filterData?.length > 0
                                  ? i.filterData.map(item => ({
                                    value: item.id || item,
                                    label: item.name || item,
                                  }))
                                  : []
                              }
                              classNamePrefix="select2-selection"
                              styles={{
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transition: "all .2s ease",
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(180deg)"
                                    : null,
                                }),
                              }}
                            />
                          ) : (
                            <DefaultMultipleSelect
                              options={
                                i.filterData?.length > 0
                                  ? i.filterData.map(item => ({
                                    key: item.id || item,
                                    text: item.name || item,
                                    checked: item.checked || false,
                                  }))
                                  : []
                              }
                              customWidth={{
                                width: i?.customWidth || "190px",
                              }}
                              hasSelectAll={i?.hasSelectAll}
                              filtered_by={props.filtered_by[key]}
                              filtered_params={props.filtered_params}
                              isDisabled={i.isDisabled}
                              onChange={select =>
                                handleSelect(select, i.filterType || null)
                              }
                              plug={i.plug}
                              isLoading={props.isLoadingSelect}
                              search
                              shouldUpdateOptions={false}
                            />
                          )}
                        </FilteredStyled>
                      </React.Fragment>
                    ))}
                </FilterContainer>
              </div>
            </CardBody>
          </StyledCard>
        </div>
      </StyledRow>
    </>
  );
};

const StyledNums = styled.div`
  display: flex;
  width: 190px;

  .n--min {
    input {
      height: 20px;
      position: relative;
      top: 16px;
      font-size: 0.7rem;
    }
  }

  .n--max {
    input {
      height: 20px;
      position: relative;
      top: 16px;
      font-size: 0.7rem;
    }
  }
`;

const Tire = styled.span`
  position: relative;
  width: 10px;
  vertical-align: middle;
  right: 0;
  top: 17px;
`;

const CustomSelect = styled(ReactSelect)`
  min-width: 230px;

  .select2-selection__indicators {
    span {
      display: none !important;
    }
  }

  .select2-selection__control {
    &.select2-selection__control--is-focused {
      box-shadow: none !important;
      border-color: rgb(189, 195, 200) !important;

      &.select2-selection__control--menu-is-open {
        box-shadow: none !important;
        border-color: rgb(189, 195, 200) !important;
      }
    }
  }
`;

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  vertical-align: center;
  padding-right: 0;
`;

const FilteredStyled = styled.div`
  margin-right: 8px;
  margin-bottom: 5px;
  p {
    margin-bottom: 6px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: ${props => props.cardcolor && `${props.cardcolor}`};
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  /* max-width: ${({ customwidth }) => `${customwidth || "190px"}`}; */
  margin-right: 8px;
  margin-bottom: 5px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormFilters.defaultProps = {
  disableFilterBy: false,
  cardcolor: "#f8f8fb",
};

DynamicFormFilters.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  onDateRangeChange: PropTypes.func,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  dateFilters: PropTypes.array,
  onFilterSelect: PropTypes.func,
  style: PropTypes.object,
  filterTitle: PropTypes.any,
  filtered_params: PropTypes.any,
  filtered_by: PropTypes.array,
  disableFilterBy: PropTypes.bool,
  cardcolor: PropTypes.string,
  isLoadingSelect: PropTypes.bool,
  FilterContainerClass: PropTypes.string,
  filterDelay: PropTypes.number,
};

export default DynamicFormFilters;
